<template>
  <Card>
    <CardHeader>
      <CardTitle>System Overview</CardTitle>
    </CardHeader>
    <CardContent v-if="system" class="space-y-4">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div class="rounded-lg border p-4">
          <p class="text-xs text-muted-foreground">
            Role
          </p>
          <p class="font-medium">
            {{ system.user_role }}
          </p>
        </div>
        <div class="rounded-lg border p-4">
          <p class="text-xs text-muted-foreground">
            Updated At
          </p>
          <p class="font-medium">
            {{ system.updated_at }}
          </p>
        </div>
        <div class="rounded-lg border p-4">
          <p class="text-xs text-muted-foreground">
            Procedures
          </p>
          <p class="font-medium">
            {{ system.procedures_count }}
          </p>
        </div>
        <div class="rounded-lg border p-4">
          <p class="text-xs text-muted-foreground">
            Active Runs
          </p>
          <p class="font-medium">
            {{ system.active_checklists_count }}
          </p>
        </div>
      </div>
    </CardContent>
    <CardContent v-else>
      <p class="text-sm text-muted-foreground">
        Loading...
      </p>
    </CardContent>
  </Card>
</template>

<script setup>
import { inject } from 'vue'
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../../../resources/js/components/ui/card/index.js'

const system = inject('businessSystem')
</script>
